import * as React from "react";

export default class BPMButton extends React.PureComponent<{
    style?: React.CSSProperties, onClick?: () => void,
    title?: string,
    icon?: string | JSX.Element,
    active?: boolean
    className?: string
}> {
    public render() {
        return <div className={'button ' + (this.props.active ? 'active' : '') + (this.props.className || '')} style={this.props.style} onClick={this.props.onClick}>
            {this.props.title && <span className='title'>{this.props.title}</span>}
            {this.props.icon ? (() => {
                if (typeof this.props.icon == 'string') {
                    return <img src={this.props.icon} />
                }
                return this.props.icon
            })() : null}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Button.tsx